/**
 * @generated SignedSource<<c575ce6e46bf2c737f5c98ccd7c32fd0>>
 * @relayHash 99fffa3126e6de3f47d400aacb871c33
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 99fffa3126e6de3f47d400aacb871c33

import type { ConcreteRequest } from 'relay-runtime';
export type UnminimizeCommentInput = {
  clientMutationId?: string | null | undefined;
  isStaffActor?: boolean | null | undefined;
  reason?: string | null | undefined;
  subjectId: string;
};
export type unminimizeCommentMutation$variables = {
  input: UnminimizeCommentInput;
};
export type unminimizeCommentMutation$data = {
  readonly unminimizeComment: {
    readonly clientMutationId: string | null | undefined;
    readonly unminimizedComment: {
      readonly id?: string;
      readonly isMinimized: boolean;
      readonly minimizedReason: string | null | undefined;
      readonly pendingMinimizeReason?: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type unminimizeCommentMutation$rawResponse = {
  readonly unminimizeComment: {
    readonly clientMutationId: string | null | undefined;
    readonly unminimizedComment: {
      readonly __typename: "IssueComment";
      readonly __isNode: "IssueComment";
      readonly id: string;
      readonly isMinimized: boolean;
      readonly minimizedReason: string | null | undefined;
      readonly pendingMinimizeReason?: string | null | undefined;
    } | {
      readonly __typename: string;
      readonly __isNode?: string;
      readonly id?: string;
      readonly isMinimized: boolean;
      readonly minimizedReason: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type unminimizeCommentMutation = {
  rawResponse: unminimizeCommentMutation$rawResponse;
  response: unminimizeCommentMutation$data;
  variables: unminimizeCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMinimized",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minimizedReason",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*:: as any*/),
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pendingMinimizeReason",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "IssueComment",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "unminimizeCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UnminimizeCommentPayload",
        "kind": "LinkedField",
        "name": "unminimizeComment",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unminimizedComment",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "unminimizeCommentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UnminimizeCommentPayload",
        "kind": "LinkedField",
        "name": "unminimizeComment",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "unminimizedComment",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v6/*:: as any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*:: as any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "99fffa3126e6de3f47d400aacb871c33",
    "metadata": {},
    "name": "unminimizeCommentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "521b37c67de466fc160c8564b686d75b";

export default node;
